import type { ReactNode } from 'react';
import { Tooltip } from 'radix-ui';
import { Kbd } from './Kbd';

/** A tooltip on its child, with an optional shortcut. */
export function Tip({ label, keys, side = 'top', children }: { label: ReactNode; keys?: string[]; side?: 'top' | 'bottom' | 'left' | 'right'; children: ReactNode }) {
  return (
    <Tooltip.Root delayDuration={350}>
      <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content className="tooltip" side={side} sideOffset={8}>
          {label}
          {keys && <Kbd keys={keys} />}
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
}
